import { Input } from 'antd'
import React, { useState, useEffect } from 'react'
import "./styles/acl.css"
import { ReactComponent as UnCheckedIcon } from "../../../../../assets/svg/checkbox.svg"
import { ReactComponent as CheckedIcon } from '../../../../../assets/svg/uncheckbox.svg'
import { ReactComponent as DeleteIcon } from '../../../../../assets/svg/delete.svg'
import { Http } from '../../../../../helpers/axois'
import { useSelector } from 'react-redux'
import { Modal } from '../../../../../helpers/commonUi'

const AclFormDrawer = ((props: any) => {
    const { aclFormData, getForms, isSolo = false }: any = props;
    const { componentAcl } = aclFormData;
    const [tabList, setTabList] = useState(["A8Config", "A8Data", "A8Func", "A8Astro", "A8Gen"])
    const [selectedTab, setSelectedTab] = useState<string>("A8Config")
    const [filterValue, setFilterValue] = useState<any>("")
    const [crossAppValue, setCrossAppValue] = useState<any>("")
    const { onClose } = props;
    const [data, setData] = useState<any>({})
    const [localComponentAcl, setLocalComponentAcl] = useState<any>(componentAcl)
    const [crossAppAcl, setCrossAppAcl] = useState<any>({})
    const [astroAcl, setAstroAcl] = useState<any>({})
    const [astroValue, setAstroValue] = useState<string>("")
    useEffect(() => {
        if (!isSolo) {
            setTabList([...tabList, "A8Flow"])
        } else if (isSolo) {
            setTabList([...tabList, "A8Solo"]);
        }
    }, [])

    useEffect(() => {
        if (componentAcl && componentAcl.a8Astro) {
            setAstroAcl(componentAcl.a8Astro)
        }
    }, [componentAcl])

    useEffect(() => {
        if (selectedTab === "A8Config") {
            getConfiguration()
        } else if (selectedTab === "A8Data") {
            getData()
        } else if (selectedTab === "A8Func") {
            getFunctions()
        }
        setFilterValue("")
        setCrossAppValue("")
        // setLocalComponentAcl(componentAcl)
    }, [selectedTab])
    const { appVersion, appBranch, selectedApp } = useSelector((state: any) => state.apps)

    const getConfiguration = () => {
        const appId = selectedApp.id
        const version = appVersion && appVersion[appId].versionId;
        const currentBranchId = appBranch && appBranch[appId] && appBranch[appId].branchId
        Http.get(`/app/${appId}/config?versionId=${version}&branchId=${currentBranchId}`).subscribe((configRes: any) => {
            setData({
                ...data,
                configList: configRes.map((o: any) => { return { ...o, key_: o.key, visible: false } })
            })
        });
    }

    const getData = () => {
        const appId = selectedApp.id
        const version = appVersion && appVersion[appId].versionId;
        Http.get(`/app/${appId}/collections?versionId=${version}`).subscribe((dataRes: any) => {
            if (localComponentAcl && localComponentAcl.a8data) {
                let crossAppData: any = {}
                let a8data = {};
                Object.keys(localComponentAcl.a8data).forEach((coll: string) => {
                    let flag = false;
                    dataRes.forEach((val: any) => {
                        if (val.coll_name === coll) {
                            flag = true
                            return;
                        }
                    })
                    if (!flag) {
                        crossAppData = { ...crossAppData, [coll]: localComponentAcl.a8data[coll] }
                    }
                    else {
                        a8data = { ...a8data, [coll]: localComponentAcl.a8data[coll] }
                    }
                })
                setCrossAppAcl(crossAppData)
                setLocalComponentAcl({ ...localComponentAcl, a8data })
            }
            setData({
                ...data,
                dataList: dataRes
            })
        });
    }

    const getFunctions = () => {
        const appId = selectedApp.id
        const version = appVersion && appVersion[appId].versionId;
        Http.get(`/apps/${appId}/functions?versionId=${version}`).subscribe((serviceRes: any) => {
            setData({
                ...data,
                funcList: serviceRes,
            })
        });
    }

    const onChange = (key: string, id: any, type?: any) => {
        if (key === "config") {
            let a8config = (localComponentAcl && localComponentAcl.a8config) ? localComponentAcl.a8config : {}
            if (localComponentAcl && localComponentAcl.a8config && localComponentAcl.a8config[id]) {
                delete a8config[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8config
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8config: {
                        ...a8config,
                        [id]: 2
                    }
                })
            }
        } else if (key === "func") {
            let a8func = (localComponentAcl && localComponentAcl.a8func) ? localComponentAcl.a8func : {}
            if (localComponentAcl && localComponentAcl.a8func && localComponentAcl.a8func[id]) {
                delete a8func[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8func
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8func: {
                        ...a8func,
                        [id]: 32
                    }
                })
            }
        } else if (key === "a8flow") {
            let a8flow = (localComponentAcl && localComponentAcl.a8flow) ? localComponentAcl.a8flow : {}
            let permissions: any = getPermissions(a8flow[id])
            const permissionNo = [64, 32, 16, 8, 4, 2];
            const permissionName = ["executeInHistory", "execute", "delete", "create", "update", "read"]
            let val = a8flow[id] ? a8flow[id] : 0;
            let index = permissionName.findIndex((name) => name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            if (localComponentAcl && localComponentAcl.a8flow && localComponentAcl.a8flow[id] && val === 0) {
                delete a8flow[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8flow
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8flow: {
                        ...a8flow,
                        [id]: val
                    }
                })
            }
        } else if (key === 'a8solo') {
            let a8solo = (localComponentAcl && localComponentAcl.a8solo) ? localComponentAcl.a8solo : {}
            if (localComponentAcl && localComponentAcl.a8solo && localComponentAcl.a8solo[id]) {
                delete a8solo[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8solo
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8solo: {
                        ...a8solo,
                        [id]: 32
                    }
                })
            }
        } else if (key === "data") {
            let a8data = (localComponentAcl && localComponentAcl.a8data) ? localComponentAcl.a8data : {}
            let permissions: any = getPermissions(a8data[id])
            const permissionNo = [32, 16, 8, 4, 2];
            const permissionName = ["execute", "delete", "create", "update", "read"]
            let val = a8data[id] ? a8data[id] : 0;
            let index = permissionName.findIndex((name) => name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            if (val === 0) {
                delete a8data[id];
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8data: {
                        ...a8data,
                    }
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8data: {
                        ...a8data,
                        [id]: val
                    }
                })
            }
        } else if (key === "crossCollectionData") {
            let a8data = crossAppAcl ? crossAppAcl : {}
            let permissions: any = getPermissions(a8data[id])
            const permissionNo = [32, 16, 8, 4, 2];
            const permissionName = ["execute", "delete", "create", "update", "read"]
            let val = a8data[id] ? a8data[id] : 0;
            let index = permissionName.findIndex((name) => name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            setCrossAppAcl({ ...a8data, [id]: val })
        } else if (key === "astro") {
            let a8astro = astroAcl ? astroAcl : {}
            let permissions: any = getPermissions(a8astro[id])
            const permissionNo = [32, 16, 8, 4, 2];
            const permissionName = ["execute", "delete", "create", "update", "read"]
            let val = a8astro[id] ? a8astro[id] : 0;
            let index = permissionName.findIndex((name) => name === type)
            if (permissions[type]) {
                val = val - permissionNo[index];
            } else {
                val = val + permissionNo[index];
            }
            setAstroAcl({ ...a8astro, [id]: val })
        } else if (key === 'a8gen') {
            let a8gen = (localComponentAcl && localComponentAcl.a8gen) ? localComponentAcl.a8gen : {}
            if (localComponentAcl && localComponentAcl.a8gen && localComponentAcl.a8gen[id]) {
                delete a8gen[id]
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8gen
                })
            } else {
                setLocalComponentAcl({
                    ...localComponentAcl,
                    a8gen: {
                        ...a8gen,
                        [id]: 32
                    }
                })
            }
        }

    }

    const getPermissions = ((value: any) => {
        const permissionNo = [64, 32, 16, 8, 4, 2];
        const permissionName = ["executeInHistory", "execute", "delete", "create", "update", "read"]
        let res = {
            create: false,
            execute: false,
            read: false,
            delete: false,
            update: false,
            executeInHistory: false
        }
        if (!value) {
            return res;
        } else {
            for (let i = 0; i < permissionNo.length; i++) {
                if (value - permissionNo[i] >= 0) {
                    res = { ...res, [permissionName[i]]: true }
                    value = value - permissionNo[i];
                }
            }
        }
        return res;
    })

    const formUpdate = (() => {
        const appId = selectedApp.id
        const currentBranchId = appBranch && appBranch[appId] && appBranch[appId].branchId
        let data: any = {
            name: aclFormData.formName,
            displayName: aclFormData.displayName,
            appId: aclFormData.appId,
            themeId: aclFormData.theme,
            version: aclFormData.versionId,
            branchId: currentBranchId,
            isV2: aclFormData.isV2 ? aclFormData.isV2 : false,
        }
        let componentAclData = localComponentAcl ? localComponentAcl : {};
        if (componentAclData || crossAppAcl || astroAcl) {
            let astroData = astroAcl;
            if (Object.values(astroAcl).includes(0)) {
                Object.keys(astroAcl).forEach((col) => {
                    if (astroAcl[col] === 0) {
                        delete astroData[col]
                    }
                })
            }
            let crossCollection = crossAppAcl;
            if (Object.values(crossAppAcl).includes(0)) {
                Object.keys(crossAppAcl).forEach((col) => {
                    if (crossAppAcl[col] === 0) {
                        delete crossCollection[col]
                    }
                })
            }
            let a8Data = componentAclData.a8data ? componentAclData.a8data : {}
            data = { ...data, componentAcl: { ...componentAclData, a8Astro: astroData, a8data: { ...a8Data, ...crossCollection } } }
        }
        Http.put(`/forms/${aclFormData.formId}`, data).subscribe((formRes) => {
            getForms(aclFormData.versionId)
            props.pushToast && props.pushToast(
                { type: 'success', message: 'Form updated successfully' }
            )
            onClose();
        }, (err) => {
            props.pushToast && props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'Form updation failed' }
            )
        })

    })

    const onEnter = (() => {
        if (!crossAppValue.includes(".") || crossAppValue.includes(" ")) {
            props.pushToast && props.pushToast(
                { type: 'error', message: 'Invalid cross app collection name.' }
            )
        } else {
            setCrossAppAcl({
                ...crossAppAcl,
                [crossAppValue]: 0
            })
            setCrossAppValue("")
        }
    })

    const onEnterAstro = () => {
        if (!astroValue.includes(".") || astroValue.includes(" ")) {
            props.pushToast && props.pushToast(
                { type: 'error', message: 'Invalid astro collection name.' }
            )
        } else {
            setAstroAcl({
                ...astroAcl,
                [astroValue]: 0
            })
            setAstroValue("")
        }
    }

    const handleDeleteData = ((key: any) => {
        let a8data = { ...crossAppAcl }
        delete a8data[key]
        setCrossAppAcl({ ...a8data })
    })
    return (
        <div className='acl_drawer'>
            <div style={{ height: "44px", width: "100%", background: "rgba(149, 171, 211, 0.17)", padding: "0px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div className='acl_title'>
                    Access Control List
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <button className='acl_cancel' style={{ outline: 0 }} onClick={(() => { onClose() })}>Cancel</button>
                    <button className='acl_submit' onClick={(() => { formUpdate() })}>Submit</button>
                </div>
            </div>
            <div className='acl_cont' style={{ height: "calc(100% - 50px)" }}>
                <div className='acl_tabs'>
                    {
                        tabList.map((tab: any) => {
                            return <div onClick={(() => { setSelectedTab(tab) })} className={`acl_tab ${tab === selectedTab && "active_acl_tab"}`}>{tab}</div>
                        })
                    }
                </div>
                {selectedTab === "A8Data" ? <div style={{ paddingTop: "11px", paddingBottom: "9px" }}>
                    <label style={{ fontSize: "14px", color: "#052f35 " }}>Cross App collection name</label>
                    <Input
                        value={crossAppValue}
                        onChange={((e: any) => {
                            const val = e.target.value
                            setCrossAppValue(val)
                        })}
                        onPressEnter={(() => { onEnter() })}
                        style={{ background: "#fffff", height: "40px", width: "100%", borderRadius: "4px" }}
                        placeholder={`Ex appId.collectionName`}
                    />
                </div> : null}
                {selectedTab === "A8Astro" ? <div style={{ paddingTop: "11px", paddingBottom: "9px" }}>
                    <label style={{ fontSize: "14px", color: "#052f35 " }}>Astro Connection name</label>
                    <Input
                        value={astroValue}
                        onChange={((e: any) => {
                            const val = e.target.value
                            setAstroValue(val)
                        })}
                        onPressEnter={(() => { onEnterAstro() })}
                        style={{ background: "#fffff", height: "40px", width: "100%", borderRadius: "4px" }}
                        placeholder={`Ex ConnectionName.TableName`}
                    />
                </div> : null}
                <div style={{ paddingTop: "11px" }}>
                    {selectedTab === "A8Data" ? <label style={{ fontSize: "14px", color: "#052f35 " }}>Permission List</label> : null}
                    <Input
                        value={filterValue}
                        onChange={((e: any) => {
                            const val = e.target.value
                            setFilterValue(val)
                        })}
                        style={{ background: "#fffff", height: "40px", width: "100%", borderRadius: "4px" }}
                        placeholder={`Search ${selectedTab} name...`}
                        suffix={
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.6 16.2C12.7974 16.2 16.2 12.7974 16.2 8.6C16.2 4.40264 12.7974 1 8.6 1C4.40264 1 1 4.40264 1 8.6C1 12.7974 4.40264 16.2 8.6 16.2Z" stroke="#B1B5BD" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M17 16.9999L15.4 15.3999" stroke="#B1B5BD" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        }
                    />
                </div>
                {selectedTab === "A8Config" ? <ConfigurationList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8config) ? localComponentAcl.a8config : {}} onChange={onChange} list={data.configList ? data.configList : []} /> : null}
                {selectedTab === "A8Data" ? <DataList handleDeleteData={handleDeleteData} crossAppAcl={crossAppAcl} setCrossAppAcl={setCrossAppAcl} filterValue={filterValue} getPermissions={getPermissions} componentAcl={(localComponentAcl && localComponentAcl.a8data) ? localComponentAcl.a8data : {}} onChange={onChange} list={data.dataList ? data.dataList : []} /> : null}
                {selectedTab === "A8Func" ? <FunctionsList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8func) ? localComponentAcl.a8func : {}} onChange={onChange} list={data.funcList ? data.funcList : []} /> : null}
                {selectedTab === "A8Flow" ? <FlowList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8flow) ? localComponentAcl.a8flow : {}} onChange={onChange} getPermissions={getPermissions}></FlowList> : null}
                {selectedTab === "A8Astro" ? <AstroList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8astro) ? localComponentAcl.a8astro : {}} onChange={onChange} getPermissions={getPermissions} astroAcl={astroAcl} setAstroAcl={setAstroAcl}></AstroList> : null}
                {selectedTab === "A8Solo" ? <A8SoloList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8solo) ? localComponentAcl.a8solo : {}} onChange={onChange}></A8SoloList> : null}
                {selectedTab === "A8Gen" ? <A8GenList filterValue={filterValue} componentAcl={(localComponentAcl && localComponentAcl.a8gen) ? localComponentAcl.a8gen : {}} onChange={onChange}></A8GenList> : null}
            </div>
        </div>
    )
})

const A8SoloList = ((props: any) => {
    const { filterValue, componentAcl, onChange } = props;
    let list:any = ["generateSequenceId","getSessionInfo","sendMail","assignToUser","getSignedURL","nlpService","noOfAvailableAgent","avgQueueWaitTime","businessHoursStatus","getChatTranscript",  "message",
    "getChatVariables",  "setChatVariables",  "deleteChatVariables",   "getUserVariables", "setUserVariables",  "deleteUserVariables"];
    const handleChange = ((key: any) => {
        if (componentAcl[key]) {
            onChange("a8solo", key)
        } else {
            onChange("a8solo", key)
        }
    })
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>EXECUTE</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {
                    list.filter((val: any) => val.toLowerCase().includes(filterValue?.toLowerCase())).map((name: any, index: number) => {
                        return (
                            <div key={index} className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{name}</span>
                                <div style={{ width: "50%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(name) })}>
                                        {componentAcl && componentAcl[name] ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
})

const A8GenList = ((props: any) => {

    const { filterValue, componentAcl, onChange } = props;
    let list: any = ["summarise", "sentimentAnalysis"];
    const handleChange = ((key: any) => {
        if (componentAcl[key]) {
            onChange("a8gen", key)
        } else {
            onChange("a8gen", key)
        }
    })
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>EXECUTE</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {
                    list.filter((val: any) => val.toLowerCase().includes(filterValue?.toLowerCase())).map((name: any, index: number) => {
                        return (
                            <div key={index} className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{name}</span>
                                <div style={{ width: "50%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(name) })}>
                                        {componentAcl && componentAcl[name] ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
})

const AstroList = ((props: any) => {
    const { astroAcl, setAstroAcl, getPermissions, filterValue, onChange } = props;
    const handleDeleteData = ((key: any) => {
        let a8astro = { ...astroAcl }
        delete astroAcl[key]
        setAstroAcl({ ...astroAcl })
    })

    const [deleteModal, setDeleteModal] = useState(false)
    const [deletedData, setDeletedData] = useState("")
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 220px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "250px", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>READ</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>CREATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>UPDATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>DELETE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>EXECUTE</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {Object.keys(astroAcl).filter((val: any) => val.toLowerCase().includes(filterValue.toLowerCase())).map((list: any, index: number) => {
                    let permissions = getPermissions(astroAcl[list]);
                    const isExecuteRawQuery = list.includes('$executeRawQuery') ? true : false;
                    return (
                        <div key={index} className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                            <div style={{ width: "250px", gap: "10px" }} className='truncate flex' title={list}>
                                <div style={{ cursor: "pointer" }} onClick={(() => { setDeleteModal(true); setDeletedData(list) })}>
                                    <DeleteIcon />
                                </div>
                                <span className='truncate' style={{ fontSize: "14px", color: "#292D32" }}>{list}</span>
                            </div>
                            <div style={{ width: "50px", paddingRight: "10px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: isExecuteRawQuery ? "no-drop" : "pointer" }}>
                                {isExecuteRawQuery ? (
                                    <span>
                                        {permissions.read ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                ) : (
                                    <span onClick={(() => { onChange("astro", list, "read") })}>
                                        {permissions.read ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                )}
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: isExecuteRawQuery ? "no-drop" : "pointer" }}>
                                {isExecuteRawQuery ? (
                                    <span>
                                        {permissions.create ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                ) : (
                                    <span onClick={(() => { onChange("astro", list, "create") })}>
                                        {permissions.create ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                )}
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: isExecuteRawQuery ? "no-drop" : "pointer" }}>
                                {isExecuteRawQuery ? (
                                    <span>
                                        {permissions.update ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                ) : (
                                    <span onClick={(() => { onChange("astro", list, "update") })}>
                                        {permissions.update ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                )}
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: isExecuteRawQuery ? "no-drop" : "pointer" }}>
                                {isExecuteRawQuery ? (
                                    <span>
                                        {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                ) : (
                                    <span onClick={(() => { onChange("astro", list, "delete") })}>
                                        {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                )}
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: !isExecuteRawQuery ? "no-drop" : "pointer" }}>
                                {isExecuteRawQuery ? (
                                    <span onClick={(() => { onChange("astro", list, "execute") })}>
                                        {permissions.execute ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                ) : (
                                    <span>
                                        {permissions.execute ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
            <Modal
                id="deleteForm"
                dataTestId="delete_form"
                unmountOnCancel={true}
                visible={deleteModal}
                title="Delete Astro Connection"
                onCancel={() => {
                    setDeleteModal(false)
                    setDeletedData("")
                }}
                // mode='Delete'
                deleteOptions={{
                    type: "Form",
                    validateString: deletedData
                }}
                footer={{
                    enable: true,
                    okText: 'DELETE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        setDeleteModal(false)
                        handleDeleteData(deletedData)
                        setDeletedData("")
                    }
                }}
            />
        </div>
    )
})


const FlowList = (props: any) => {
    const { filterValue, componentAcl, onChange, getPermissions } = props;
    let list: any = ["dedupe", "generateSequenceId", "getGroupById", "getGroups", "getSignedURL", "getNextAvailableAgent", "getProcessDefinitions", "getUserById", "getUsers", "getUsersByGroupId", "startNewProcessInstance", "sendMail", "getGroupsByUserId", "generateChecksum", "startNewProcessInstanceByAppId"];
    const handleChange = ((key: any, type: string) => {
        if (componentAcl[key]) {
            onChange("a8flow", key, type)
        } else {
            onChange("a8flow", key, type)
        }
    })
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "25%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>EXECUTE</h5>
                <h5 style={{ width: "25%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>EXECUTE IN HISTORY</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {
                    list.filter((val: any) => val.toLowerCase().includes(filterValue.toLowerCase())).map((name: any) => {
                        let permissions = getPermissions(componentAcl[name])
                        return (
                            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{name}</span>
                                <div style={{ width: "25%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(name, "execute") })}>
                                        {permissions.execute ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                                <div style={{ width: "25%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(name, "executeInHistory") })}>
                                        {permissions.executeInHistory ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

const ConfigurationList = ((props: any) => {
    const { list, componentAcl, onChange, filterValue } = props;
    const handleChange = ((key: any) => {
        if (componentAcl[key]) {
            onChange("config", key)
        } else {
            onChange("config", key)
        }
    })
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>READ</h5>
            </div>
            <div>
                {
                    list.filter((val: any) => val.key.toLowerCase().includes(filterValue.toLowerCase())).map((config: any, index: number) => {
                        return (
                            <div key={index} className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{config.key} </span>
                                <div style={{ width: "50%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(config.key) })}>
                                        {componentAcl && componentAcl[config.key] ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
})
const DataList = ((props: any) => {
    const { list, onChange, componentAcl, getPermissions, filterValue, crossAppAcl, handleDeleteData } = props;
    const handleChange = ((key: string, colName: string) => {
        onChange("data", colName, key)
    })
    const handleCrossAppChange = ((key: string, colName: string) => {
        onChange("crossCollectionData", colName, key)
    })
    const [deleteModal, setDeleteModal] = useState(false)
    const [deletedData, setDeletedData] = useState("")
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 220px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "250px", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>READ</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>CREATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>UPDATE</h5>
                <h5 style={{ width: "50px", fontSize: "13px", color: "#909BAD" }}>DELETE</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {list.filter((val: any) => val.coll_name.toLowerCase().includes(filterValue.toLowerCase())).map((collection: any) => {
                    let permissions = getPermissions(componentAcl[collection.coll_name])
                    return (
                        <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                            <div style={{ width: "250px" }} className='truncate' title={collection.coll_name}>
                                <span className='truncate' style={{ fontSize: "14px", color: "#292D32" }}>{collection.coll_name}</span>
                            </div>
                            <div style={{ width: "50px", paddingRight: "10px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleChange("read", collection.coll_name) })}>
                                    {permissions.read ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleChange("create", collection.coll_name) })}>
                                    {permissions.create ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleChange("update", collection.coll_name) })}>
                                    {permissions.update ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleChange("delete", collection.coll_name) })}>
                                    {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                        </div>
                    )
                })}
                {Object.keys(crossAppAcl).length ? <div style={{ borderBottom: "1px dashed #B1B5BD", margin: "0px 0px 20px 0px" }}></div> : null}
                {Object.keys(crossAppAcl).filter((val: any) => val.toLowerCase().includes(filterValue.toLowerCase())).map((collection: any) => {
                    let permissions = getPermissions(crossAppAcl[collection])
                    return (
                        <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                            <div style={{ width: "250px", gap: "10px" }} className='truncate flex' title={collection}>
                                <div style={{ cursor: "pointer" }} onClick={(() => { setDeleteModal(true); setDeletedData(collection) })}>
                                    <DeleteIcon />
                                </div>
                                <span className='truncate' style={{ fontSize: "14px", color: "#292D32" }}>{collection}</span>
                            </div>
                            <div style={{ width: "50px", paddingRight: "10px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleCrossAppChange("read", collection) })}>
                                    {permissions.read ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleCrossAppChange("create", collection) })}>
                                    {permissions.create ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleCrossAppChange("update", collection) })}>
                                    {permissions.update ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                            <div style={{ width: "50px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                <span onClick={(() => { handleCrossAppChange("delete", collection) })}>
                                    {permissions.delete ? <CheckedIcon /> : <UnCheckedIcon />}
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
            <Modal
                id="deleteForm"
                dataTestId="delete_form"
                unmountOnCancel={true}
                visible={deleteModal}
                title="Delete Cross App Collection"
                onCancel={() => {
                    setDeleteModal(false)
                    setDeletedData("")
                }}
                // mode='Delete'
                deleteOptions={{
                    type: "Form",
                    validateString: deletedData
                }}
                footer={{
                    enable: true,
                    okText: 'DELETE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        setDeleteModal(false)
                        handleDeleteData(deletedData)
                        setDeletedData("")
                    }
                }}
            />
        </div>
    )
})
const FunctionsList = ((props: any) => {
    const { list, componentAcl, onChange, filterValue } = props;
    const handleChange = ((key: any) => {
        if (componentAcl[key]) {
            onChange("func", key)
        } else {
            onChange("func", key)
        }
    })
    return (
        <div style={{ paddingTop: "20px", height: "calc(100% - 100px)" }}>
            <div className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                <h5 className='truncate' style={{ width: "50%", fontSize: "13px", color: "#909BAD" }}>NAME</h5>
                <h5 style={{ width: "50%", fontSize: "13px", color: "#909BAD", textAlign: "center" }}>EXECUTE</h5>
            </div>
            <div style={{ overflow: "auto", height: "95%" }}>
                {
                    list.filter((val: any) => val.displayName.toLowerCase().includes(filterValue.toLowerCase())).map((fun: any, index: number) => {
                        return (
                            <div key={index} className='' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: 500, paddingBottom: "18px" }}>
                                <span className='truncate' style={{ width: "50%", fontSize: "14px", color: "#292D32" }}>{fun.displayName}</span>
                                <div style={{ width: "50%", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                                    <span onClick={(() => { handleChange(fun.name) })}>
                                        {componentAcl && componentAcl[fun.name] ? <CheckedIcon /> : <UnCheckedIcon />}
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
})
export default AclFormDrawer;
